import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import MessagesInbox from "../components/MessagesInbox";
import Seo from "../components/Seo";
import PageGlow from "../components/PageGlow";

export default function Messages() {
  const { user } = useAuth();
  const role = user?.role;
  const [searchParams] = useSearchParams();
  const appId = searchParams.get("app") || "";
  const selfPath = `/messages${appId ? `?app=${appId}` : ""}`;

  if (!user || (role !== "candidate" && role !== "employer")) {
    return (
      <main className="relative max-w-2xl mx-auto px-4 py-24 text-center" data-testid="messages-page">
        <PageGlow subtle />
        <h1 className="font-display text-3xl font-bold tracking-tight text-zinc-950">Your messages</h1>
        {user ? (
          <>
            <p className="mt-3 text-zinc-600">Admin chat oversight lives in the Control Tower.</p>
            <Link to="/control-tower" data-testid="messages-control-tower-link"
              className="mt-6 inline-block bg-zinc-950 text-white text-sm font-semibold px-6 py-3 rounded-md hover:bg-zinc-800 transition-colors duration-200">
              Open Control Tower
            </Link>
          </>
        ) : (
          <>
            <p className="mt-3 text-zinc-600">Log in to see your conversations.</p>
            <Link to={`/login?next=${encodeURIComponent(selfPath)}`} data-testid="messages-login-link"
              className="mt-6 inline-block bg-zinc-950 text-white text-sm font-semibold px-6 py-3 rounded-md hover:bg-zinc-800 transition-colors duration-200">
              Log in
            </Link>
          </>
        )}
      </main>
    );
  }

  return (
    <main className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14" data-testid="messages-page">
      <PageGlow subtle />
      <Seo title="Messages | HiredToday" description="Your application conversations." path="/messages" />
      <h1 className="font-display text-3xl sm:text-4xl tracking-tight font-bold text-zinc-950">Messages</h1>
      <p className="mt-2 text-zinc-600">
        {role === "employer"
          ? "Every candidate conversation across your team, anyone in the company can jump in and take over."
          : "Every conversation with employers about your applications."}
      </p>
      <div className="mt-8">
        <MessagesInbox role={role} initialAppId={appId} />
      </div>
    </main>
  );
}
